<template>
  <div>
    <van-nav-bar :title="t('whatsappPage.title')" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="flex items-center justify-center flex-col mt-[40px]">
      <div class="flex items-center justify-center">
        <img :src="getAssetsFile('activity/youjiantou.png')" alt="" class="w-[24px] h-[18px] ">
        <div class="color-[#359E77] text-[23px] mx-[4px]">{{ t('whatsappPage.title') }}</div>
        <img :src="getAssetsFile('activity/youjiantou.png')" alt="" class="w-[24px] h-[18px] rotate-190">
      </div>
      <img :src="getAssetsFile('activity/what.webp')" alt="" class="w-full h-[98px]">
    </div>
  </div>
</template>
<script setup lang="ts">
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { Button } from "@/components/Button"
const { t } = useI18n();
const router = useRouter();
const onClickLeft = () => {
  router.back()
}
</script>
<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.rotate-190 {
  transform: rotate(180deg);
}
</style>
<route lang="json5">
    {
      name: 'whatsapp',
      meta: {
        title: 'whatsapp',
        i18n: 'menus.whatsapp'
      },
    }
    </route>
